import { classic } from "./classic";

export const icons = {
  classic,
};
